import {createContext} from 'react'

export const userInfoContext=createContext();